var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCap3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 266,
    viewBox: "0 0 282 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.647 37.3566C248.196 36.8933 250.825 37.197 253.202 38.2292C255.578 39.2613 257.597 40.9757 259.001 43.1556C260.405 45.3354 261.132 47.8828 261.091 50.4758C261.049 53.0688 260.241 55.591 258.768 57.7235C257.294 59.856 255.223 61.503 252.814 62.4565C250.405 63.4099 247.768 63.6269 245.235 63.0801C242.703 62.5332 240.389 61.2471 238.586 59.3842C236.783 57.5213 235.572 55.1653 235.106 52.614C234.795 50.9187 234.821 49.1787 235.183 47.4937C235.544 45.8087 236.234 44.2118 237.214 42.7945C238.193 41.3771 239.442 40.1673 240.889 39.2342C242.336 38.301 243.953 37.663 245.647 37.3566Z",
    fill: "#FF90E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.303 262.92L180.727 245.702L180.632 245.617L199.756 224.475C209.472 212.864 190.515 180.961 157.42 153.205C124.325 125.448 89.6231 112.35 79.9067 123.961L53.7321 152.768L1.99707 79.5858L171.382 108.889L280.303 262.92Z",
    fill: "#FF90E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7321 152.767L79.8485 123.891C89.5649 112.28 124.267 125.378 157.362 153.135C190.457 180.891 209.414 212.794 199.697 224.405L167.616 259.881L167.525 259.818C176.191 247.768 157.312 216.423 124.743 189.108C91.6478 161.352 56.9368 148.267 47.2314 159.875L53.7321 152.767Z",
    fill: "#FF90E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.742 189.166C157.311 216.481 176.19 247.826 167.524 259.876L167.079 260.447C157.363 272.058 122.663 258.971 89.568 231.215C56.4731 203.458 37.5141 171.544 47.2305 159.933C56.9469 148.323 91.6448 161.398 124.742 189.166Z",
    fill: "#FF90E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2091 153.506L53.6891 152.777L1.9541 79.5954L171.372 108.893L280.243 262.898L180.667 245.681",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.832 47.9604C261.294 50.5107 260.989 53.1404 259.958 55.5168C258.926 57.8933 257.214 59.9099 255.037 61.3116C252.86 62.7132 250.316 63.437 247.728 63.3913C245.14 63.3457 242.623 62.5327 240.495 61.0551C238.368 59.5776 236.726 57.5019 235.776 55.0904C234.827 52.679 234.613 50.0402 235.162 47.5077C235.71 44.9752 236.997 42.6627 238.858 40.8627C240.72 39.0627 243.073 37.856 245.621 37.3953C249.037 36.7774 252.558 37.5434 255.411 39.5248C258.264 41.5061 260.214 44.5405 260.832 47.9604Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192 139L192.408 138.831C197.16 136.87 241.803 117.021 249 64",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M249.512 36.8836C249.655 36.2862 254.284 16.7486 240.984 2.36282",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.176 13.3783C247.259 21.5877 249.547 36.8907 249.547 36.8907",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M249.503 36.8958C249.971 36.3883 265.867 18.5503 259.724 1.69272",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7695 124.066C89.486 112.456 124.188 125.554 157.283 153.31C190.378 181.067 209.335 212.97 199.618 224.58",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.523 259.865L167.078 260.437C157.362 272.048 122.662 258.961 89.5671 231.204C56.4722 203.447 37.5131 171.533 47.2295 159.923C56.9459 148.312 91.6458 161.399 124.741 189.156C157.302 216.426 176.19 247.816 167.523 259.865Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2295 159.923L79.8053 123.9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.613 259.926L200.189 223.903",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.209 156.586C74.3531 175.131 106.101 218.733 167.941 244.78",
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap3);
export default __webpack_public_path__ + "static/media/cap3.a21820453e5116fa09531631980995c1.svg";
export { ForwardRef as ReactComponent };